<template>
  <div class="w-full max-w-screen px-4">
    <!-- Top Section -->
    <div class="mt-8">
      <h2 class="text-2xl font-bold mb-4 pt-8">Base2 AI Dashboard</h2>
      <AISearch />
    </div>

    <!-- Stats Row -->
    <div class="mt-8">
      <StatsRow :id="id" />
    </div>

    <!-- Recommendations -->
    <div class="grid grid-cols-1 md:grid-cols-3 mt-8 gap-4">
      <ReccomendationCard />
      <UpdatesCard />
      <HealthCard />
    </div>

    <!-- First Row -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 h-full mt-8">
      <div class="md:col-span-2 flex flex-col h-full">
        <CostGraphCard class="h-full" />
      </div>

      <!-- Fourth Row: Prompt Tester -->
    <!-- <div class="grid grid-cols-1 mt-8 gap-4">
        <PromptTesterCard class="h-full" :id="id" :activeType="activeType"/> -->
  <!--</div>-->
      <div class="md:col-span-1 flex flex-col gap-4 h-full">
        <MonthlyOverviewCard class="flex-1" />
        <BackupCard class="flex-1" :id="id" />
    </div>
  </div>

    <!-- Second Row -->
    <div class="grid grid-cols-1 md:grid-cols-9 gap-4 h-[500px] mt-8">
      <div class="md:col-span-3 flex flex-col h-full gap-4">
        <MonitoredCard class="h-full" :id="id" />
      </div>
      <div class="md:col-span-4 flex flex-col gap-4 h-full">
        <ComparisonCostDeployment class="h-full" />
        <TestDeployments
          v-if="id && activeType"
          class="h-full"
          :id="id"
          :entityId="id"
          :activeType="activeType"
          :showGraph="true"
        />
      </div>
      <div class="md:col-span-2 flex flex-col h-full">
        <FeaturesCard class="h-full" :id="id" :activeType="activeType" />
      </div>
    </div>

    <!-- Third Row -->
    <div class="grid grid-cols-1 md:grid-cols-7 gap-4 h-[500px] mt-8">
      <div class="md:col-span-3 flex flex-col h-full">
        <AlertsCard class="h-full" :id="id" />
      </div>
      <div class="md:col-span-2 flex flex-col h-full gap-4">
        <SlackCard class="h-full" :id="id" summaryOnly />
        <ProActiveCard class="h-full" />
      </div>
      <div class="md:col-span-2 flex flex-col h-full">
        <ZendeskSummaryCard class="h-full" :id="id || ''" :activeType="activeType || ''" />
      </div>
    </div>

    <!-- Fourth Row: Updated Prompt Tester -->
    <div class="grid grid-cols-1 mt-8 gap-4">
      <CombinedMetrics :id="id" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// General Components
import AISearch from '../AISearch/SearchBar.vue'
import StatsRow from '../components/CardFormatting/StatsRow.vue'

// Recommendation Cards
import ReccomendationCard from '../components/Cards/StatCards/ReccomendationsRow/ReccomendationCard.vue'
import UpdatesCard from '../components/Cards/StatCards/ReccomendationsRow/UpdatesCard.vue'
import HealthCard from '../components/Cards/StatCards/ReccomendationsRow/HealthCard.vue'

// AI and Overview Cards
import CostGraphCard from '../components/Cards/GraphCards/CostGraphCard.vue'
import MonthlyOverviewCard from '../components/Cards/AICards/MonthlyOverviewCard.vue'
import BackupCard from '../components/Cards/AICards/BackupCard.vue'
import CombinedMetrics from '../components/Cards/AICards/TimeSeriesCard/CombinedMetrics/CombinedMetrics.vue'
// import PromptTesterCard from '../components/Cards/AICards/PromptTesterCard.vue'
// import UpdatedPromptTesterCard from '../components/Cards/AICards/UpdatedPromptTesterCard.vue'

// Info and Feature Cards
import MonitoredCard from '../components/Cards/InfoCards/MonitoredCard.vue'
import ComparisonCostDeployment from '../components/Cards/InfoCards/CostAgainstDeploymentsCard.vue'
import TestDeployments from '../components/Cards/InfoCards/TestDeployments.vue'
import FeaturesCard from '../components/Cards/InfoCards/FeaturesCard.vue'
import ProActiveCard from '../components/Cards/InfoCards/ProActiveCard.vue'
import AlertsCard from '../components/Cards/InfoCards/AlertsCard.vue'
import SlackCard from '../components/Cards/InfoCards/SlackCard.vue'
import ZendeskSummaryCard from '../components/Cards/InfoCards/ZendeskSummaryCard.vue'

export default {
  name: 'Dashboard',
  props: {
    id: {
      type: String,
      default: 'AllContracts'
    }
  },
  components: {
    AISearch,
    StatsRow,
    ReccomendationCard,
    UpdatesCard,
    HealthCard,
    CostGraphCard,
    MonthlyOverviewCard,
    BackupCard,
    MonitoredCard,
    ComparisonCostDeployment,
    TestDeployments,
    FeaturesCard,
    ProActiveCard,
    AlertsCard,
    SlackCard,
    ZendeskSummaryCard,
    CombinedMetrics
  },
  computed: {
    ...mapGetters(['activeType'])
  }
}
</script>



// WEBPACK FOOTER //
// src/views/AIPage.vue